import { Hero } from "../components/home/Hero";
import { Marquee } from "../components/site/Marquee";
import { AboutSection } from "../components/home/AboutSection";
import { EcosystemSection } from "../components/home/EcosystemSection";
import { BenefitsSection } from "../components/home/BenefitsSection";
import { GovernanceSection } from "../components/home/GovernanceSection";
import { HowItWorks } from "../components/home/HowItWorks";
import { CtaBanner } from "../components/site/CtaBanner";
import { Seo } from "../components/site/Seo";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="MST | Multiple Stream Team"
        description="MST is a private, invite-only network of entrepreneurs, investors, founders, professionals, and business leaders building multiple streams of income, businesses, relationships, and generational wealth together."
        path="/"
      />
      <Hero />
      <Marquee />
      <AboutSection />
      <EcosystemSection />
      <BenefitsSection />
      <GovernanceSection />
      <HowItWorks />
      <CtaBanner />
    </main>
  );
}
